<template>
  <section>
    <div v-if="loading">
      <h1 class="mb-2 text-lg font-bold">
        Tareas ({{ filteredTasks.length }})
      </h1>
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">

        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
            <app-icon v-bind:name="'search'" v-bind:classname="'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'"></app-icon>
            <input type="text" class="input w-full sm:w-64 box px-10 text-gray-700"
              placeholder="Buscar por codigo" v-model="filter.slug">
            <div class="inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center">
              <app-icon v-bind:name="'chevron-down'" v-bind:classname="'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'"></app-icon>
                <div class="inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20">
                    <div class="dropdown-box__content box p-5">
                        <div class="grid grid-cols-12 gap-4 row-gap-3">
                            <div class="col-span-6">
                              <div class="text-xs">Cuenta</div>
                              <select class="input w-full border mt-2 flex-1" v-model="filter.account" required>
                                  <option disabled selected>Seleccione la cuenta</option>
                                  <option v-for="account in accounts" v-bind:value="account.id">
                                    {{ account.name }} - {{ account.country.prefix }}
                                  </option>
                                  <option value="">Todos</option>
                              </select>
                            </div>
                            <div class="col-span-6">
                              <div class="text-xs">Estado</div>
                              <select class="input w-full border mt-2 flex-1" v-model="filter.state" required>
                                  <option disabled>Seleccione el estado</option>
                                  <option v-for="state in states" v-bind:value="state.id">
                                      {{ state.name }}
                                    </option>
                                  <option value="">Todos</option>
                              </select>
                            </div>
                            <div class="col-span-6">
                              <div class="w-full sm:w-auto flex">
                                  <button @click="filter = clearFilter()" class="button mt-28 text-white bg-theme-1 shadow-md mr-2">Borrar Filtro</button>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-span-6">
                  <div class="text-xs">Estado</div>
                  <select
                    class="input w-full border mt-2 flex-1"
                    v-model="filter.state"
                    required
                  >
                    <option disabled>Seleccione el estado</option>
                    <option v-for="state in states" v-bind:value="state.id">
                      {{ state.name }}
                    </option>
                    <option value="">Todos</option>
                  </select>
                </div>
                <div class="col-span-6">
                  <div class="w-full sm:w-auto flex">
                    <button
                      @click="filter = clearFilter()"
                      class="button mt-28 text-white bg-theme-1 shadow-md mr-2"
                    >
                      Borrar Filtro
                    </button>
                  </div>
                </div>
            </div>
        </div>

        <div class="w-full sm:w-auto flex">
          <router-link
            to="/admin/traffic/tasks-without-finish"
            class="button text-white bg-theme-1 shadow-md mr-2"
            >Tareas sin finalizar</router-link
          >
          <a
            data-target="#task"
            data-toggle="modal"
            class="button text-white bg-theme-1 shadow-md mr-2"
            >Crear Tarea</a
          >
        </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="overflow-auto intro-y">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="whitespace-no-wrap">NOMBRE</th>
              <th class="text-center whitespace-no-wrap">ESTADO</th>
              <th class="text-center whitespace-no-wrap">FECHA ENTREGA</th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr class="intro-x" v-for="task in filteredTasks">
              <td>
                <a href="#" class="font-medium whitespace-no-wrap">{{
                  task.name | limit
                }}</a>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ task.slug }}
                </div>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ task.created_at }}
                </div>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ task.campaign_attribute.name }} - {{ task.team_name }}
                </div>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ task.campaign_attribute.project_name }}
                </div>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ task.campaign_attribute.project_account_name }} -
                  {{ task.campaign_attribute.project_account_country_prefix }}
                </div>
              </td>
              <td class="w-40">
                <div class="flex items-center justify-center">
                  <template v-for="user in users">
                    <div
                      class="w-10 h-10 image-fit zoom-in"
                      v-if="task.created_by === user.id"
                      :key="`user-created_by-${user.id}`"
                    >
                      <img
                        :alt="task.user_created_name"
                        class="tooltip rounded-full tooltipstered"
                        :src="
                          user.avatar
                            ? user.avatar
                            : `/static/images/profile.png`
                        "
                        :title="task.user_created_name"
                      />
                    </div>
                  </template>
                  <template v-for="user in users">
                    <div
                      class="w-10 h-10 image-fit zoom-in -ml-5"
                      v-if="task.user_id === user.id"
                      :key="`user-user_id-${user.id}`"
                    >
                      <img
                        :alt="task.user_name"
                        class="tooltip rounded-full tooltipstered"
                        :src="
                          user.avatar
                            ? user.avatar
                            : `/static/images/profile.png`
                        "
                        :title="task.user_name"
                      />
                    </div>
                  </template>
                </div>
                <div class="flex items-center justify-center">
                  {{ task.state_name }} - {{ task.hours }}hs
                </div>
              </td>
              <td>
                <button
                  class="button button--sm w-24 text-white"
                  :class="dateClass(task)"
                >
                  {{ task.date }}
                </button>
              </td>
              <td class="table-report__action w-56">
                <div class="flex justify-center items-center">
                  <router-link
                    :to="'/admin/traffic/task/' + task.id"
                    class="cursor-pointer flex items-center mr-3"
                  >
                    <app-icon name="edit" classname="w-4 h-4 mr-2"></app-icon>
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->
    </div>

    <app-loading v-else />

    <!-- Modal -->
    <div class="modal" id="task">
      <div class="modal__content modal__content--md">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Crear Tarea</h2>
        </div>
        <form
          @submit.prevent="createTask"
          enctype="multipart/form-data"
          class="form-task"
        >
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
              <label>Nombre</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="task.name"
                required
              />
            </div>
            <div class="col-span-12 sm:col-span-12 xxl:col-span-12">
              <label>Descripcion</label>
              <textarea
                class="input w-full border mt-2"
                rows="3"
                v-model="task.description"
              ></textarea>
            </div>
            <div class="col-span-6 sm:col-span-12">
              <label>Fecha de entrega</label>
              <input
                type="date"
                class="input w-full border mt-2 flex-1"
                v-model="task.date"
                required
              />
            </div>
            <div class="col-span-6 sm:col-span-12">
              <label>Proyecto</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="task.project_id"
                required
              >
                <option value="" disabled>Seleccione...</option>
                <option v-for="project in projects" :value="project.id">
                  {{ project.name }} - {{ project.account.name }}
                  {{ project.account.country.prefix }}
                </option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Campaña</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="task.campaign_id"
                required
              >
                <option value="" disabled>Seleccione...</option>
                <option
                  v-for="campaign in filteredCampaigns"
                  :value="campaign.id"
                >
                  {{ campaign.name }}
                </option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Equipo</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="task.team_id"
                required
              >
                <option disabled>Seleccione el equipo</option>
                <option v-for="team in teams" :value="team.id">
                  {{ team.name }}
                </option>
              </select>
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Url Archivo (opcional)</label>
              <MultiSelect
                v-model="task.path"
                :options="options"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                class="mt-2"
              />
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-gray-700 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="button w-20 bg-theme-1 text-white"
              id="create"
            >
              Crear
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal End -->
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'
import MultiSelect from '@/components/assets/MultiSelect/MultiSelect'

export default {
  name: 'AdminListTask',
  data() {
    return {
      loading: false,
      task: this.defineTask(),
      filter: this.clearFilter(),
      task_validated: false,
      task_loading: 11,
      today: null,
      options: [],
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      tasks: 'getTasks',
      users: 'getUsers',
      campaigns: 'getCampaigns',
      teams: 'getTeams',
      projects: 'getProjects',
      accounts: 'getAccounts',
      states: 'getTaskStates',
    }),
    filteredCampaigns() {
      this.task.campaign_id = ''
      return this.campaigns.filter((v) => {
        return v.project_id == this.task.project_id
      })
    },
    filteredTasks() {
      let tasksFiltered = this.tasks.filter((item) => {
        var slug = this.filter.slug
          ? item.slug.toLowerCase().includes(this.filter.slug.toLowerCase())
          : true
        var account = this.filter.account
          ? item.campaign_attribute.project_account_id === this.filter.account
          : true
        var state = this.filter.state
          ? item.state_id === this.filter.state
          : true

        return slug && account && state
      })

      return tasksFiltered.slice(0, 500)
    },
  },
  mounted() {
    $('#task').on('hidden.bs.modal', () => {
      this.defineTask()
    })

    let newDate = new Date()
    let dd = ('0' + newDate.getDate()).slice(-2)
    let mm = ('0' + (newDate.getMonth() + 1)).slice(-2)
    let yyyy = newDate.getFullYear()

    this.today = `${yyyy}-${mm}-${dd}`
  },
  async beforeMount() {
    try {
      await this.getListTasksMongo('task')
      this.getList('user')
      this.getList('campaign')
      this.getList('project')
      this.getList('account')
      this.getList('taskstate')
    } catch (error) {
    } finally {
      this.loading = true
    }
  },
  methods: {
    defineTask() {
      return {
        name: '',
        description: '',
        date: '',
        campaign_id: '',
        team_id: '',
        entity: 'task',
        path: [],
        project_id: '',
      }
    },
    clearFilter() {
      return {
        slug: null,
        account: null,
        state: null,
      }
    },
    createTask() {
      var vm = this
      window.$('#create').button('loading')
      vm.store(vm.task)
        .then((item) => {
          window.$('#task').modal('hide')
          vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/tasks')
        })
        .catch((error) => {
          console.log('FAILURE!!')
        })
        .finally(() => {
          window.$('#create').button('reset')
          vm.loading = true
          this.defineTask()
        })
    },
    dateClass(task) {
      let date = task.date
      let styleClass = null

      if (task.state_id == 4) {
        styleClass = 'bg-theme-1'
      } else {
        if (date > this.today) {
          styleClass = 'bg-theme-9'
        } else {
          if (date == this.today) {
            styleClass = 'bg-theme-12'
          } else {
            styleClass = 'bg-theme-6'
          }
        }
      }
      return styleClass
    },
    addTag(newTag) {
      this.options.push(newTag)
      this.task.path.push(newTag)
    },
    ...mapActions(['getListTasksMongo', 'getList', 'getAll', 'store']),
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
    MultiSelect,
  },
}
</script>



// WEBPACK FOOTER //
// ListTask.vue?2f9277f8